import { cookie, retrieveAndParse, write, makeRandomString } from "../../utilities/Utility";

import {
    writePrecursorXMLSingle,
    writePrecursorXMLLines
} from "../../writes/udo";

export const types = {
    SET_DEFAULT: 'SCAFFOLD/SET_DEFAULT',
    SET_ATTRIBUTE_BY_OBJ: 'SCAFFOLD/SET_ATTRIBUTE_BY_OBJ',
    SET_STATE: 'SCAFFOLD/SET_STATE',
    ADD_SCAFFOLD: 'SCAFFOLD/ADD_SCAFFOLD'
}

const defaultState = {
    loading: false,
    temp: null,
    storedScaffolds: [
        {
            title: "Business",
            locked: false,
            fields: [
                {
                    label: "Address",
                    value: "123 NW Street"
                },
                {
                    label: "Name",
                    value: "Bob"
                },
                {
                    label: "Phone",
                    value: "555-123-4444"
                },
            ],
            buttons: [
                { label: "Cancel" },
                { label: "Submit" },
            ],
            window: {
                xLeft: 300,
                yTop: 100,
                sizeW: 600,
                sizeH: 300,
                ogSizeW: 600,
                ogSizeH: 300,
                zIndex: 49
            }
        },
        {
            title: "Customer",
            locked: false,
            fields: [
                {
                    label: "Account Number",
                    value: "12345678"
                },
                {
                    label: "Address",
                    value: "124 SW Street"
                },
                {
                    label: "Billing Contact",
                    value: "Mandy"
                },
                {
                    label: "E-Mail",
                    value: "mandy@email.copm"
                },
                {
                    label: "Phone",
                    value: "555-123-4567"
                },
                {
                    label: "Tracking Number",
                    value: "991001"
                },
            ],
            buttons: [
                { label: "Accept" },
                { label: "Cancel" }
            ],
            window: {
                xLeft: 600,
                yTop: 200,
                sizeW: 600,
                sizeH: 600,
                ogSizeW: 600,
                ogSizeH: 600,
                zIndex: 50
            }
        }],
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case types.SET_DEFAULT:
            return defaultState;
        case types.SET_ATTRIBUTE_BY_OBJ:
            return Object.assign({}, state, action.obj);
        case types.SET_STATE:
            return Object.assign({}, state, action.newState);
        case types.ADD_SCAFFOLD:
            return Object.assign({}, state, {
                'storedScaffolds': [...state.storedScaffolds, newScaffold(action.obj)]
            })

        default:
            return state;
    }
}

const newScaffold = (obj) => {
    return obj;
}


export const actions = {
    setDefault: () => {
        return { type: types.SET_DEFAULT };
    },
    setAttributeByObj: (obj) => {
        return { type: types.SET_ATTRIBUTE_BY_OBJ, obj };
    },
    setState: (newState) => ({ type: types.SET_STATE, newState }),
    addScaffold: (obj) => ({ type: types.ADD_SCAFFOLD, obj }),
    updateScaffold: (obj) => {
        return function (dispatch, getState) {
            const changeObj = {
                loading: false,
                'storedScaffolds': obj
            }
            dispatch(actions.setAttributeByObj(changeObj));
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/scaffold/scaffoldData.js